import React from 'react'
import {BsGithub,BsLinkedin,BsTwitter,BsInstagram} from'react-icons/bs'
import {FaFacebookF,FaLinkedinIn} from 'react-icons/fa'
import {FiGithub} from 'react-icons/fi'

function SocialMedia() {
  return (
    <div className='app__social'>
       <div>
        <a href="https://www.linkedin.com/in/sami-kachai/" target='_blank' rel='noreferrer noopener'>
           <FaLinkedinIn/>
           </a>
       </div>
       <div>
        <a href="https://twitter.com/Sami_Kachai" target='_blank' rel='noreferrer noopener'>
           <BsTwitter/>
           </a>
       </div>
       <div>
        <a  href="https://www.facebook.com/sami.kachai/" target='_blank' rel='noreferrer noopener'>
           <FaFacebookF/>
           </a>
       </div>
       <div>
        <a href="https://github.com/Sami-Kachai" target='_blank' rel='noreferrer noopener'>
           <FiGithub/>
           </a>
       </div>
        </div>
  )
}

export default SocialMedia